import { create } from 'zustand';

interface ManageStore {
  isOpen: boolean;
  open(): void;
  close(): void;
}

export const useTaskGroupTemplatesManageStore = create<ManageStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
